import React, { useCallback, useState } from "react";
import _ from "lodash";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import AmountEditor from "../../../../components/AmountEditor/AmountEditor";

function MobilePositionAmountEditor(props) {
    const {getLangPath} = useLangContext();
    const {
        amount,
        amountChangeHandler,
        assetInstance,
        className,
        currentPrice,
        error,
        lots,
        lotsChangeHandler,
        maxLots,
    } = props;

    const [inputFriendly, setInputFriendly] = useState(localStorage.getItem('inputFriendly') !== 'false');

    const amountChangeHandlerEvent = useCallback((e) => {
        amountChangeHandler(e.currentTarget.innerText.replaceAll(',', '.'));
    }, [amountChangeHandler]);

    const amountBlurHandler = useCallback((e) => {
        const amount = _.floor(parseFloat(e.currentTarget.innerText) || 0);
        let value = amount < assetInstance.getMinOrderSizeAmount(currentPrice) ? assetInstance.getMinOrderSizeAmount(currentPrice) : amount;
        if (maxLots !== undefined && assetInstance.amountToLots(value, currentPrice) > maxLots) {
            value = assetInstance.lotsToAmount(maxLots, currentPrice)?.toFixed(2);
        }
        if (value > assetInstance.getMaxOrderSizeAmount(currentPrice)) value = assetInstance.getMaxOrderSizeAmount(currentPrice);
        if (amount !== value || e.currentTarget.innerText.length !== value.toString().length) {
            amountChangeHandler(value);
        }
    }, [amountChangeHandler, assetInstance, currentPrice, maxLots]);

    const lotsChangeHandlerEvent = useCallback((e) => {
        lotsChangeHandler(e.currentTarget.innerText.replaceAll(',', '.'));
    }, [lotsChangeHandler]);

    const lotsBlurHandler = useCallback((e) => {
        const lots = assetInstance.roundLots(parseFloat(e.currentTarget.innerText) || 0);
        let value = lots < assetInstance.getMinOrderSizeLots() ? assetInstance.getMinOrderSizeLots() : lots;
        if (maxLots !== undefined && value > maxLots) value = maxLots;
        if (value > assetInstance.getMaxOrderSizeLots()) value = assetInstance.getMaxOrderSizeLots();
        if (lots !== value || e.currentTarget.innerText.length !== value.toString().length) {
            lotsChangeHandler(value);
        }
    }, [assetInstance, lotsChangeHandler, maxLots]);

    const setInputFriendlyHandler = useCallback(() => {
        setInputFriendly(prevState => {
            localStorage.setItem('inputFriendly', !prevState ? 'true' : 'false');
            return !prevState;
        });
    }, []);

    const presetItemClickHandler = useCallback((e) => {
        const value = e.currentTarget.dataset.value;
        const sizeIncrement = assetInstance.getMinOrderSizeIncrement();
        if (value === 'plus') {
            if (maxLots !== undefined && lots >= maxLots) {
                return;
            }
            const maxOrderSizeLots = assetInstance.getMaxOrderSizeLots();
            lotsChangeHandler(_.min([_.round(parseFloat(lots) + sizeIncrement, 2), maxOrderSizeLots]));
        } else if (value === 'minus') {
            const minOrderSizeLots = assetInstance.getMinOrderSizeLots();
            lotsChangeHandler(_.max([_.round(parseFloat(lots) - sizeIncrement, 2), minOrderSizeLots]));
        }
    }, [assetInstance, lots, lotsChangeHandler, maxLots]);

    return <AmountEditor
        className={className}
        editMainAmount={inputFriendly}
        error={!!error && getLangPath(error, {
            max_lots_size: assetInstance.getMaxOrderSizeLots(),
            min_lots_size: assetInstance.getMinOrderSizeLots(),
        })}
        label={getLangPath('lite_version.order.amount')}
        mainAmountBlurHandler={amountBlurHandler}
        mainAmountChangeHandler={amountChangeHandlerEvent}
        mainAmountValue={amount.toString()}
        mainAmountLabel={amount ? `$${amount}` : getLangPath('lite_version.order.enter_sum')}
        mainAmountPrefix={'$'}
        minusDisabled={lots <= assetInstance.getMinOrderSizeLots()}
        onButtonClick={presetItemClickHandler}
        plusDisabled={maxLots !== undefined && lots >= maxLots}
        secondaryAmountBlurHandler={lotsBlurHandler}
        secondaryAmountChangeHandler={lotsChangeHandlerEvent}
        secondaryAmountLabel={lots
            ? getLangPath('lite_version.order.lots_count', {number: lots})
            : getLangPath('lite_version.order.enter_lots')
        }
        secondaryAmountPostfix={getLangPath('lite_version.order.lots')}
        secondaryAmountValue={lots.toString()}
        switchAmountHandler={setInputFriendlyHandler}
    />
}

export default MobilePositionAmountEditor;
